/** Moedas disponíveis no sistema  */
export interface Moeda {
    id: number;
    nome: string;
    codigo: string;
    simbolo: string;
}

export const moedaReal: Moeda = {id: 1, nome: 'Real', codigo: 'BRL', simbolo: 'R$'};
export const moedaDolar: Moeda = {id: 2, nome: 'Dólar', codigo: 'USD', simbolo: '$'};
export const moedaEuro: Moeda = {id: 3, nome: 'Euro', codigo: 'EUR', simbolo: '€'};

export const moedas: Moeda[] = [
    moedaReal,
    moedaDolar,
    moedaEuro
];

/** Todas as moedas estrangerias */
export const moedasEstrangeras: Moeda[] = moedas.filter(moeda => moeda.id !== moedaReal.id);

/** Verifica se a moeda é igual a Real */
export function isMoedaReal(id: number): boolean {
    return id === moedaReal.id;
}

/** Verifica se a moeda é igual a Dolar */
export function isMoedaDolar(id: number): boolean {
    return id === moedaDolar.id;
}

/** Verifica se a moeda é igual a Euro */
export function isMoedaEuro(id: number): boolean {
    return id === moedaEuro.id;
}

